// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, Input,  OnChanges, SimpleChanges } from '@angular/core';
import { D3eService } from 'src/services/d3e-service';
import { IDeviceSetBare } from 'src/types/device-sets';
import { TopNType } from '../dashboard.types';
import { SelectedOrgMethod } from 'src/shared/selectedOrg';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-top-n-threats',
    templateUrl: './top.n.threats.component.html',
    styleUrls: ['./top.n.threats.component.scss', '../component.common.scss'],
    standalone: false
})

export class TopNThreatsComponent implements OnChanges {
  @Input() timeInterval: string;
  @Input() deviceSet: IDeviceSetBare;
  @Input() refreshTrigger: number;
  @Input() selectedOrgId: string;

  topNList: TopNType[] = null;

  headerTopNList = '';

  dashboardTopNThreatsLoaded = false;

  fTopTitle: string;
  fTopNone: string;
  constructor(
    private d3eService: D3eService,
    private translate: TranslateService
  ) {
      this.translate.get(['DASH_TT_TITLE', 'DASH_TT_NONE']).subscribe(vals => {
          this.fTopTitle = vals['DASH_TT_TITLE'];
          this.fTopNone = vals['DASH_TT_NONE'];
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ( changes.deviceSet !== undefined ) {
      this.deviceSet = changes.deviceSet.currentValue;
    } 

    if ( changes.selectedOrgId !== undefined ) {
      this.selectedOrgId = changes.selectedOrgId.currentValue;
      if (this.refreshTrigger == null) {
          this.getTopNThreats();
      }
    }

    if ( changes.refreshTrigger !== undefined && changes.refreshTrigger.firstChange === false) {
      this.refreshTrigger = changes.refreshTrigger.currentValue;
    }

    if ( this.refreshTrigger ) {
      this.getTopNThreats();
    }
  }

  getHeaderQueryParams() {
    const headerQueryParams = {};
    if ( this.timeInterval !== undefined && this.timeInterval != null ) {
      headerQueryParams['time'] = this.timeInterval;
    } else {
      headerQueryParams['time'] = '336';
    }
    if ( this.deviceSet !== undefined && this.deviceSet != null ) {
      headerQueryParams['deviceSetId'] = this.deviceSet.id.toString();
    }
    headerQueryParams['sensorId'] = this.headerTopNList;
    return headerQueryParams;
  }

  public getTopNThreats() {
    this.topNList = null;
    let deviceSetId = null;
    if ( this.deviceSet !== undefined && this.deviceSet != null) {
       deviceSetId = this.deviceSet.id;
    }

    const selectedOrg = SelectedOrgMethod.getSelectedOrg(this.selectedOrgId);

    const queryJson = {
      'time': this.timeInterval,
      'deviceSet': deviceSetId,
      'n': 5,
      'selectedOrgId': selectedOrg,
    };

    this.d3eService.getTopNThreats(queryJson)
        .pipe(untilDestroyed(this))
        .subscribe(results => {
            const newTopNList: TopNType[] = [];
            let newHeaderTopNList = '';
            results.forEach(element => {
                const historyParams = {};
                historyParams['time'] = this.timeInterval;
                if ( deviceSetId != null) {
                  historyParams['deviceSetId'] = deviceSetId.toString();
                }
                historyParams['sensorId'] = element['sensor'];
                const newTopN: TopNType = {
                  'id': element['sensor'].toString(10),
                  'name': element['sensor_name'],
                  'threatCount': element['threat_count'],
                  'historyParams': historyParams,
                };
                newTopNList.push(newTopN);
                newHeaderTopNList += element['sensor'] + ',';
            });
            this.topNList = newTopNList;
            this.headerTopNList = newHeaderTopNList;
            this.dashboardTopNThreatsLoaded = true;
    });
  }
}
